import { type PraticaDtoStato } from '@framework/api-client/api/backoffice/schemas/praticaDtoStato.ts';
import { assertNever } from '@framework/engine/utils/assertNever.ts';
import { StyledTag } from '@framework/ui/components/tag/StyledTag.tsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

interface IDossierStateTagProps {
  state?: PraticaDtoStato | null;
  mini?: boolean;
}

/**
 * Stato di una Pratica
 */
export function DossierStateTag(props: IDossierStateTagProps) {
  const { state, mini } = props;
  const dossierTagProps = useDossierStatusTag(state);

  if (!dossierTagProps) return null;

  return <StyledTag mini={mini} {...dossierTagProps} />;
}

/**
 * Ritorna le impostazioni per il tag
 *
 */
function useDossierStatusTag(state?: PraticaDtoStato) {
  const theme = useTheme();
  const { t } = useTranslation();

  const tag = useMemo(() => {
    if (!state) return;

    switch (state) {
      case 'CHIUSA':
        return {
          color: theme?.colorError ?? '#cf1322',
          children: t('stato.pratica.chiusa', 'CHIUSA'),
        };
      case 'APERTA':
        return {
          color: theme?.colorSuccess ?? '#389e0d',
          children: t('stato.pratica.aperta', 'APERTA'),
        };
    }
    assertNever(state);
  }, [state, t, theme]);

  return tag;
}
